import { render, staticRenderFns } from "./PixellotHeader.vue?vue&type=template&id=34ec5524&lang=pug&"
import script from "./PixellotHeader.vue?vue&type=script&lang=js&"
export * from "./PixellotHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/cms/cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34ec5524')) {
      api.createRecord('34ec5524', component.options)
    } else {
      api.reload('34ec5524', component.options)
    }
    module.hot.accept("./PixellotHeader.vue?vue&type=template&id=34ec5524&lang=pug&", function () {
      api.rerender('34ec5524', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/interface/header/PixellotHeader.vue"
export default component.exports